import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/Command.es.js";
const m = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...a, weights: t }));
m.displayName = "CommandIcon";
const s = m;
export {
  s as Command,
  m as CommandIcon
};
